import { render, staticRenderFns } from "./LinkToDSS.vue?vue&type=template&id=adc8509a&scoped=true&"
import script from "./LinkToDSS.vue?vue&type=script&lang=js&"
export * from "./LinkToDSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc8509a",
  null
  
)

export default component.exports